import {
  ActuatorType,
  BoilerType,
  DuctType,
  EntityType,
  HeatingNetworkType,
  type BuildingGraphNode,
} from "@eisox/api/core-api";

import { m } from "~/paraglide/messages";

export const HOUSE_MAX_DURATION_PRESENCE_DETECTION = 1800000;

export const DEFAULT_LATITUDE = 46.71109;
export const DEFAULT_LONGITUDE = 1.7191036;

export const DEFAULT_FROST_FREE_TEMPERATURE = 7;
export const DEFAULT_ABSENCE_TEMPERATURE = 16;
export const DEFAULT_PRE_COMFORT_TEMPERATURE = 18;
export const DEFAULT_NIGHT_TEMPERATURE = 18.5;
export const DEFAULT_COMFORT_TEMPERATURE = 19;

export const DEFAULT_REDUCED_FROST_FREE_TEMPERATURE = 35;

export const ENTITY_TYPE_LABELS: Record<EntityType, () => string> = {
  [EntityType.SITE]: m.entity_type_site,
  [EntityType.FLOOR]: m.entity_type_floor,
  [EntityType.HEATING_NETWORK]: m.entity_type_heating_network,
  [EntityType.URBAN_HEATING_NETWORK]: m.entity_type_urban_heating_network,
  [EntityType.HEATING_PROFILE]: m.entity_type_heating_profile,
  [EntityType.GROUP]: m.entity_type_group,
  [EntityType.BUILDING]: m.entity_type_building,
  [EntityType.ROOM]: m.entity_type_room,
  [EntityType.BOILER_ROOM]: m.entity_type_boiler_room,
  [EntityType.CONTROLLER]: m.entity_type_controller,
  [EntityType.POINT]: m.entity_type_point,
  [EntityType.USER]: m.entity_type_user,
  [EntityType.VALVE]: m.entity_type_valve,
  [EntityType.MULTISENSOR]: m.entity_type_multisensor,
  [EntityType.ACTUATOR]: m.entity_type_actuator,
  [EntityType.BOILER]: m.entity_type_boiler,
  [EntityType.HEATING_CURVE]: m.entity_type_heating_curve,
  [EntityType.AIR_HANDLER_UNIT]: m.entity_type_air_handler_unit,
  [EntityType.DUCT]: m.entity_type_duct,
  [EntityType.GATEWAY]: m.entity_type_gateway,
  [EntityType.MESH]: m.entity_type_mesh,
  [EntityType.MODULE]: m.entity_type_module,
  [EntityType.METER]: m.entity_type_meter,
  [EntityType.PLANNING]: m.entity_type_planning,
};

export const ELEMENT_SUBTYPE_LABELS: Partial<Record<NonNullable<BuildingGraphNode["subtype"]>, () => string>> = {
  [ActuatorType.PUMP]: m.actuator_type_pump,
  [ActuatorType.TWO_WAY_VALVE]: m.actuator_type_two_way_valve,
  [ActuatorType.HIGH_TEMPERATURE_RETURN_TWO_WAY_VALVE]: m.actuator_type_high_temperature_return_two_way_valve,
  [ActuatorType.THREE_WAY_VALVE]: m.actuator_type_three_way_valve,
  [ActuatorType.BYPASS_TWO_WAY_VALVE]: m.actuator_type_bypass_two_way_valve,
  [ActuatorType.FAN]: m.actuator_type_fan,
  [ActuatorType.COIL]: m.actuator_type_coil,
  [ActuatorType.DAMPER]: m.actuator_type_damper,
  [ActuatorType.RCU]: m.actuator_type_rcu,
  [ActuatorType.RECYCLE_PUMP]: m.actuator_type_recycle_pump,
  [ActuatorType.SLUDGE_REMOVER]: m.actuator_type_sludge_remover,
  [ActuatorType.RECOVERY_WHEEL]: m.actuator_type_recovery_wheel,
  [ActuatorType.DEHUMIDIFIER]: m.actuator_type_dehumidifier,
  [ActuatorType.HUMIDIFIER]: m.actuator_type_humidifier,
  [ActuatorType.FREE_COOLING]: m.actuator_type_free_cooling,
  [ActuatorType.HYDRAULIC_CHANGEOVER]: m.actuator_type_hydraulic_changeover,
  [ActuatorType.FILTER]: m.actuator_type_filter,
  [BoilerType.GAZ_FIOUL]: m.boiler_type_gaz_fioul,
  [BoilerType.HEAT_PUMP_COOLING_UNIT]: m.boiler_type_heat_pump_cooling_unit,
  [BoilerType.RCU]: m.boiler_type_rcu,
  [BoilerType.WOOD_BOILER]: m.boiler_type_wood_boiler,
  [DuctType.SUPPLY]: m.duct_type_supply,
  [DuctType.RETURN]: m.duct_type_return,
  [DuctType.OUTSIDE]: m.duct_type_outside,
  [DuctType.EXHAUST]: m.duct_type_exhaust,
  [HeatingNetworkType.SANITARY_HOT_WATER]: m.heating_network_type_sanitary_hot_water,
  [HeatingNetworkType.RADIATOR]: m.heating_network_type_radiator,
  [HeatingNetworkType.CENTRAL_AIR_HANDLING_UNIT]: m.heating_network_type_central_air_handling_unit,
  [HeatingNetworkType.AIR_HEATER]: m.heating_network_type_air_heater,
  [HeatingNetworkType.CONSTANT]: m.heating_network_type_constant,
  [HeatingNetworkType.CONVECTION_HEATER]: m.heating_network_type_convection_heater,
  [HeatingNetworkType.RADIANT_HEAT]: m.heating_network_type_radiant_heat,
};

export const EQUIPMENT_TYPES = new Set<EntityType>([
  EntityType.BOILER_ROOM,
  EntityType.BOILER,
  EntityType.HEATING_NETWORK,
  EntityType.URBAN_HEATING_NETWORK,
  EntityType.AIR_HANDLER_UNIT,
  EntityType.DUCT,
  EntityType.ACTUATOR,
]);

export const GENERATED_NAME_PATTERN = /^[\da-f]{8}(-[\da-f]{4}){3}-[\da-f]{12}/i;
